import { Component, Inject, OnDestroy, OnInit, Optional, Self } from '@angular/core';
import { FormBuilder, NgControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { APP_CONFIG } from '../../../app.config';
import { AssistantPopoverService } from '../../../common/assistant-popover.service';
import { ValidationService } from '../../../common/validation.service';
import { ValueListsService } from '../../../common/value-lists.service';
import { AppConfig } from '../../../models/config/app-config';
import { FormSubGroupControl } from '../../../models/formControls/FormSubGroupControl';
import { ValueListItem } from '../../../models/rest/valuelist/valuelist';
import { VisumErfassungSubFormComponent } from '../visum-erfassung-sub-form/visum-erfassung-sub-form.component';

@Component({
  selector: 'app-kostenuebernahme',
  templateUrl: './kostenuebernahme.component.html',
  styleUrls: ['./kostenuebernahme.component.scss']
})
export class KostenuebernahmeComponent extends VisumErfassungSubFormComponent implements OnInit, OnDestroy {

  private subscriptions: Subscription = new Subscription();
  private isOrganisation = false;

  verpflichtungserklaerungsgeberListItems: ValueListItem[];

  constructor(fb: FormBuilder,
              private validationService: ValidationService,
              private valueListsService: ValueListsService,
              assistantPopoverService: AssistantPopoverService,
              @Optional() @Self() controlDir: NgControl,
              @Inject(APP_CONFIG) public appConfig: AppConfig) {
    super(controlDir, assistantPopoverService);

    this.form = this.wrapFormGroup(fb.group({
      reisekostenUebernahme: new FormSubGroupControl(),
      lebensunterhalt: new FormSubGroupControl(),
      verpflichtungserklaerungsgeber: new FormSubGroupControl()
    }));
  }

  ngOnInit() {
    super.ngOnInit();

    this.subscriptions.add(this.valueListsService.getValueListItems('verpflichtungserklaerungsgeber_art')
    .subscribe((listItems: ValueListItem[]) => {
      this.verpflichtungserklaerungsgeberListItems = listItems;
    }));

    this.form.controls.reisekostenUebernahme.valueChanges.subscribe(value => {
      this.showOrHideVerpflichtungserklaerungsgeber(value);
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  onValidatorUpdate() {
    this.showOrHideVerpflichtungserklaerungsgeber(this.form.value.reisekostenUebernahme);
  }

  andereValueChangedHandler() {}

  private showOrHideVerpflichtungserklaerungsgeber(reisekostenUebernahme) {
    // console.log('showOrHideVerpflichtungserklaerungsgeber');
    if (reisekostenUebernahme !== this.form.value.reisekostenUebernahme && reisekostenUebernahme.organisation !== this.isOrganisation) {
      this.isOrganisation = reisekostenUebernahme.organisation;
      this.enableOrDisableControlsSynchronously(reisekostenUebernahme.organisation === true, this.form.controls.verpflichtungserklaerungsgeber);
    }
  }
}

